import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourNotificacionesPlantillas: TourDefinicion = {
  codigo: 'notificaciones-plantillas',
  titulo: 'Plantillas de correo',
  descripcion: 'Textos de los correos automáticos del sistema.',
  ruta: '/admin/notificaciones/plantillas',
  permisoMenu: Permisos.PLANTILLAS_MENU,
  pasos: [
    {
      id: 'notificaciones-plantillas:header',
      selector: '[data-testid="notificaciones-plantillas.header"]',
      titulo: 'Plantillas de correo',
      descripcion:
        'El sistema envía correos automáticos (bienvenida, recuperación, notificaciones). Aquí editas sus textos.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'notificaciones-plantillas:tabla',
      selector: '[data-testid="notificaciones-plantillas.tabla"]',
      titulo: 'Listado',
      descripcion:
        'Edita, previsualiza o elimina cada plantilla. Los cambios se aplican a los próximos envíos.',
      side: 'top',
      align: 'center',
    },
  ],
};
